import React from 'react';
import { connect } from 'react-redux';
import { components, elements } from '@peachjar/components';
import UploadParents from './UploadParentsTab';
import IntroduceParents from './IntroduceParentsTab';
import {
  toggleParentCsvUploadStatusComplete,
  toggleParentCsvHasErrors,
  setParentTabView,
} from '../setup-parent.duck';

const { Tabber } = components;
const { typography } = elements;
const { Headline1 } = typography;

const generateTabs = (
  parentTabView,
  parentCsvUploadStatusComplete,
  parentCsvHasErrors,
  handleTabView,
  haveParentsBeenLoaded
) => {
  const tabs = [
    {
      id: 1,
      isActive: parentTabView === 1,
      icon: 'Desktop',
      label: 'Upload a CSV file',
      labelSubText: 'with a list of parents in your district.',
      onClickHandler: () => handleTabView(1),
      isLocked: false,
    },
    {
      id: 2,
      isActive: parentTabView === 2,
      icon: 'Email',
      label: 'Introduce Peachjar',
      labelSubText: 'to your parents.',
      onClickHandler:
        haveParentsBeenLoaded ||
        (parentCsvUploadStatusComplete && !parentCsvHasErrors)
          ? () => {
              handleTabView(2);
            }
          : null,
      isLocked:
        !haveParentsBeenLoaded ||
        (!parentCsvUploadStatusComplete && parentCsvHasErrors),
    },
  ];
  return tabs;
};

const SetupParentContainer = ({
  haveParentsBeenLoaded,
  isUploadContinueDisabled,
  isUploading,
  uploadingErrors,
  uploadingPercentage,
  isUploadComplete,
  uploadingFilename,
  setParentUploadingFile,
  parentUploadingValidatedList,
  ncesSchoolId,
  ncesDistrictId,
  parentUploadingInstructionsClicked,
  parentUploadingTemplateCLicked,
  handleParentInstructionsClick,
  handleParentCsvClick,
  parentUploadTaskId,
  isParentIntroContinueDisabled,
  handleContinueDisable,
  parentTabView,
  parentCsvUploadStatusComplete,
  parentCsvHasErrors,
  handleTabView,
  handleParentCsvUploadStatusComplete,
  handleParentCsvHasErrors,
  isParentsSetupCompleted,
  totalUploaded,
}) => (
  <React.Fragment>
    <Headline1 style={{ margin: '1rem 0' }}>Parent Setup</Headline1>
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
      }}
    >
      <Tabber
        tabs={generateTabs(
          parentTabView,
          parentCsvUploadStatusComplete,
          parentCsvHasErrors,
          handleTabView,
          haveParentsBeenLoaded
        )}
      />
    </div>
    <div>
      {parentTabView === 1 && (
        <UploadParents
          isUploadContinueDisabled={isUploadContinueDisabled}
          isUploading={isUploading}
          uploadingErrors={uploadingErrors}
          uploadingPercentage={uploadingPercentage}
          isUploadComplete={isUploadComplete}
          uploadingFilename={uploadingFilename}
          setParentUploadingFile={setParentUploadingFile}
          parentUploadingValidatedList={parentUploadingValidatedList}
          ncesSchoolId={ncesSchoolId}
          handleParentInstructionsClick={handleParentInstructionsClick}
          handleParentCsvClick={handleParentCsvClick}
          parentUploadingInstructionsClicked={
            parentUploadingInstructionsClicked
          }
          parentUploadingTemplateCLicked={parentUploadingTemplateCLicked}
          parentUploadTaskId={parentUploadTaskId}
          haveParentsBeenLoaded={haveParentsBeenLoaded}
          handleTabView={handleTabView}
          handleParentCsvUploadStatusComplete={
            handleParentCsvUploadStatusComplete
          }
          handleParentCsvHasErrors={handleParentCsvHasErrors}
          totalUploaded={totalUploaded}
        />
      )}
      {parentTabView === 2 && (
        <IntroduceParents
          isParentIntroContinueDisabled={isParentIntroContinueDisabled}
          handleContinueDisable={handleContinueDisable}
          ncesDistrictId={ncesDistrictId}
          isParentsSetupCompleted={isParentsSetupCompleted}
        />
      )}
    </div>
  </React.Fragment>
);

const mapStateToProps = state => ({
  parentCsvUploadStatusComplete:
    state.setupParent.parentCsvUploadStatusComplete,
  parentCsvHasErrors: state.setupParent.parentCsvHasErrors,
  totalUploaded: state.setupParent.totalUploaded,
});

const mapDispatchToProps = dispatch => ({
  handleTabView: tab => {
    dispatch(setParentTabView(tab));
  },
  handleParentCsvUploadStatusComplete: boolean => {
    dispatch(toggleParentCsvUploadStatusComplete(boolean));
  },
  handleParentCsvHasErrors: boolean => {
    dispatch(toggleParentCsvHasErrors(boolean));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetupParentContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/containers/SetupParentContainer.jsx